import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import EditForm from '../managed-product/EditForm';
import Heading from '../common/Heading';
import BZAPIService from '../../services/BZAPIService';
import Loader from '../common/Loader';
import PlanProjectCell, { DeviceCountInline } from '../bsa/inventory/PlanProjectCell';
import { usePlanProjectGate } from '../bsa/inventory/usePlanProjectGate';
import { useDeviceCounts } from '../bsa/inventory/useDeviceCounts';

export default function ManagedProductEdit() {
  const { vendorId, managedProductId, managedProductName } = useParams();
  const [vendor, setVendor] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const canCreatePlanProject = usePlanProjectGate(vendorId);
  const numericId = Number(managedProductId);
  // products/new has no managed product to scan
  const managedProduct = Number.isInteger(numericId)
    ? { id: numericId, name: managedProductName || '' }
    : null;
  const deviceCounts = useDeviceCounts(
    managedProduct ? [managedProduct] : [],
    canCreatePlanProject
  );

  useEffect(() => {
    async function onLoad() {
      try {
        console.log('xxisloading');
        const vendor = await BZAPIService.getVendor(vendorId);
        console.log('vendor', vendor);
        setVendor(vendor);
        setIsLoading(false);
      } catch (e) {
        console.log('e', e);
      }
    }

    onLoad();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  if (isLoading) return <Loader text="Loading product..." />;
  const { name } = vendor.vendorData;

  return (
    <>
      <Heading
        title={`${name?.replace('Systems', 'Networks')} Managed Product`}
        subtitle={`Specify configuration details`}
        className="mb-4 mt-3"
        icon="edit"
      />
      {managedProduct && (
        <div className="mb-3">
          <DeviceCountInline
            count={deviceCounts.get(managedProduct.id)}
            canCreatePlanProject={canCreatePlanProject}
          />
          <PlanProjectCell
            managedProduct={managedProduct}
            canCreatePlanProject={canCreatePlanProject}
            withProductLabel
          />
        </div>
      )}
      <EditForm
        vendorLabel={name}
        vendorId={vendorId}
        vendorBugCategoryOptions={vendor?.vendorData?.vendorBugCategories ? vendor.vendorData.vendorBugCategories : []}
        vendorBugTypeOptions={vendor?.vendorData?.vendorBugTypes ? vendor.vendorData.vendorBugTypes : []}
        includedComponents={vendor?.vendorData?.vendorBugComponents ? vendor.vendorData.vendorBugComponents : []}
      />
    </>
  );
}

ManagedProductEdit.propTypes = {
  forms: PropTypes.func,
  vendorLabel: PropTypes.string,
  vendorId: PropTypes.string
};
